//src/mis/pages/EditRegisteredUser.jsx
import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { useMediaQuery, Divider, TextField, useTheme, Button, Chip, InputLabel, IconButton, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Autocomplete } from "@mui/material";
import { tokens } from "../../theme";
import Stack from '@mui/material/Stack';
import { Description } from "@mui/icons-material";
import Modal from '@mui/material/Modal';
import { CloseRounded } from "@mui/icons-material";
import {MachineList, MachineListUpdated} from "../data/machineList";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import env from "react-dotenv";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Edit = ({onSelected, open , onClose, departments}) => {
  const [date, setDate] = useState(new Date());
  const navigate = useNavigate();
  const { rowIndex } = useParams();
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});
  const [ row , setRow] = useState();
  const [backenderrors, setBackenderrors] = useState({});
  const [ oldMobile , setOldMobile] = useState();
  const { palette } = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const [data, setData] = useState({
    id:"",
    full_name: "",  
    email: "",
    user_pwd: "",
    // department: "",
    department: [], // Change to an array for multiple selection
    user_role:"",
    mobile:"",
  });

 
  const [mobiles , setMobiles] = useState([]);
  useEffect( () => {
    const fetchMobiles = async() =>{
        try {
            const res = await fetch(
                `${process.env.REACT_APP_USERMGMT_URL}/notes`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  }
                }
              )
              const response = await res.json();
            
              setMobiles(Object.keys(response).map(function(k){
                return (response[k].mobile)
              })); 
            
             
        }
        catch(error){
            console.log('Error fetching mobile numbers',error);
        }
    }
    fetchMobiles();  
  }, [ ] );


  const handleClose = () => {
    navigate('../maintenanceHome/2', { replace: true })    
  }

  const handleChange = (e) => {
    
    setData({ ...data, [e.target.name]: e.target.value });
       
  }
  
  const validateForm = (data) => {
    const errors = {};
    if (data.WorkType.trim() === 'Machine Maintenance' && !data.Machine.trim()) {
        errors.Machine = 'Machine is required if worktype is machine maintenance';
        console.log(errors.Machine);
    }

    return errors;
  };

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const modalStyle1 = {
    maxWidth: 500,marginLeft:"400px", marginTop:"50px",
    
      // overflow:'scroll',
    };

    const handleSubmitOnDB = async (e) => {
      e.preventDefault();
  
      const newErrors = {}; 
      if(data.mobile !== null){
        const mobileExists = mobiles.filter(m => m !== oldMobile).includes(data.mobile);
        if(mobileExists){
            newErrors.mobile = "Mobile Number already exists";        
        } 
      }          
      setBackenderrors(newErrors);
      
      if (Object.keys(newErrors).length === 0) {
        const savedUserResponse = await fetch(`${process.env.REACT_APP_USERMGMT_URL}/updateUser`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify(data),
        body: JSON.stringify({
          ...data,
          department: data.department.join(', '), // Join selected departments
        }),
        });
        //   const savedUser = await savedUserResponse.json();
        const response = await savedUserResponse.json();
          if (savedUserResponse.ok) {
            navigate(0);
            navigate("../register");
          } else {
            console.error(response);
            // Handle error response
          } 
      }
      else{
        console.log(`Form submission failed
            due to validation errors.`);
      }
    };

    const getDataFromDb = async () => {
    
        try {
          if (onSelected) {
            const { id, field, dataId} = onSelected;
            const rIndex = dataId;
            console.log(rIndex)
            setRow(dataId);      
              try { 
                  const res = await fetch(
                  `${process.env.REACT_APP_USERMGMT_URL}/notes/${rIndex}`,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                );
                const response = await res.json();
                // setData(response); 
                setData({
                  ...response,
                  department: response.department.split(', '), // Split the department string into an array
                });
                setOldMobile(data.mobile)
              } catch (error) {
                console.log(error);
              }
          }
        } catch (error) {
          console.log(error);
        }
      };
    
      useEffect(() => {
        getDataFromDb(data);   
      }, [onSelected]);

  return  (open) ?(
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
            Update User
          </Typography>
          <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseRounded />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
      
      <form onSubmit={handleSubmitOnDB}>
      
      <Box
            display="grid"
            gap="15px"
            gridTemplateColumns="repeat(3, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
              marginRight: "10px",
              marginLeft: "10px",
              marginBottom: "10px",
            }}
          >

            <TextField
            fullWidth
              label="Full Name"
              name="full_name"
              value={data.full_name}
              onChange={handleChange}
              disabled
              sx={{ gridColumn: "span 3" }}
            />  
      
      {/* <TextField
                  label="Department"
                  onChange={handleChange}
                  value={data.department}
                  name="department"
                  disabled
                  sx={{ gridColumn: "span 3", textAlign:"left" }}
                  select
                  fullWidth
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    
                  }}
                > 
                 <MenuItem value="Maintenance" key="Maintenance">Maintenance</MenuItem>
                    <MenuItem value="Supply" key="Supply">Supply</MenuItem>
                    <MenuItem value="Production" key="Production">Production</MenuItem>
                  </TextField> */}

{/* <TextField
        label="Department"
        onChange={handleChange}
        value={data.department}
        name="department"
        sx={{ gridColumn: "span 3", textAlign: "left" }}
        select
        fullWidth
      >
        {departments.map((dept) => (
          <MenuItem key={dept.id} value={dept.dept_name}>
            {dept.dept_name}
          </MenuItem>
        ))}
      </TextField> */}

{/* <FormControl fullWidth sx={{ marginTop: '10px' }}>
            <InputLabel id="department-label">Department</InputLabel>
            <Select
              labelId="department-label"
              multiple
              value={data.department}
              onChange={(event) => {
                const {
                  target: { value },
                } = event;
                setData({ ...data, department: typeof value === 'string' ? value.split(',') : value });
              }}
              renderValue={(selected) => (
                <div>
                  {selected.map((value) => (
                    <Chip
                      key={value}
                      label={value}
                      onDelete={() => {
                        const newDepartments = data.department.filter((dept) => dept !== value);
                        setData({ ...data, department: newDepartments });
                      }}
                    />
                  ))}
                </div>
              )}
            >
              {departments.map((dept) => (
                <MenuItem key={dept.id} value={dept.dept_name}>
                  {dept.dept_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <Divider sx={{ backgroundColor: '#ffffff' }} />
          <Autocomplete
  multiple
  options={departments.map(d => d.dept_name)}
  value={data.department}
  onChange={(e, value) => setData({ ...data, department: value })}
  renderTags={(tagValue, getTagProps) =>
    tagValue.map((option, index) => (
      <Chip
        key={option}
        label={option}
        {...getTagProps({ index })}
        sx={{
          backgroundColor: '#e0f7fa',
          color: '#00796b',
          '& .MuiChip-deleteIcon': {
            color: '#004d40',
          },
        }}
      />
    ))
  }
  renderInput={(params) => (
    <TextField
      {...params}
      label="Department"
      placeholder="Select Department"
      error={Boolean(errors.department)}
      helperText={errors.department}
      sx={{ gridColumn: "span 3", textAlign: "left", width: '100%' }} // Match the size with the role TextField
    />
  )}
  sx={{ gridColumn: "span 3", width: '100%' }} // Ensure the Autocomplete takes the full width
/>

                  <TextField
                  label="Role"
                  fullWidth
                  onChange={handleChange}
                  value={data.user_role}
                  disabled
                  name="role"
                  sx={{ gridColumn: "span 3", textAlign:"left" }}
                  select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    
                  }}
                >
                    {/* <MenuItem value="Maintenance Admin" key="admin">Maintenance Admin</MenuItem>
                    <MenuItem value="Supply Admin" key="supplyadmin">Supply Admin</MenuItem>
                    <MenuItem value="Production Admin" key="prodadmin">Production Admin</MenuItem>
                    <MenuItem value="Read Only" key="readOnly">Read Only</MenuItem> */}

                    <MenuItem value="">No selection</MenuItem>
                    <MenuItem value="Admin" key="admin">Admin</MenuItem>
                    <MenuItem value="Super Admin" key="superadmin">Super Admin</MenuItem>
                    <MenuItem value="Operator" key="operator">Operator</MenuItem>
                    <MenuItem value="Supervisor" key="supervisor">Supervisor</MenuItem>
                    
                  </TextField>

              <TextField
              label="Mobile Number"
             fullWidth
              onChange={handleChange}
              value={data.mobile}
              name="mobile"
              sx={{ gridColumn: "span 3" }}
            />
             {backenderrors.mobile &&
                        <span style={{ color: 'red'}} className="error-message">
                            {backenderrors.mobile}
                        </span>
             }
              
          <TextField
              label="Email"
              onChange={handleChange}
              value={data.email}
              fullWidth
              name="email"
              sx={{ gridColumn: "span 3" }}
            />
            
            <TextField
              label="Password"
              type="password"
              fullWidth
              onChange={handleChange}
              value={data.user_pwd}
              name="user_pwd"
              sx={{ gridColumn: "span 3" }}
            />

            </Box>
           
            <DialogActions sx={{ justifyContent: 'center' }}>
            <Button onClick={onClose} color="secondary"
              sx={{ marginRight: 2, ':hover': { bgcolor: '#4863C0', color: 'white' } }}>
              Cancel
            </Button>
            <Button
              type="submit"
              sx={{ backgroundColor: '#4863A0', ':hover': { bgcolor: '#4863C0', color: 'white' } }}
              variant="contained"
            >
              Update
            </Button>
          </DialogActions>
    </form>
     </DialogContent>
    </Dialog>
  ): ""
  
};

export default Edit;